var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('browse',{attrs:{"idKey":"process_instance_id","readOnly":_vm.readOnly,"type":_vm.processType,"columns":_vm.columns,"dataSource":_vm.dataSource,"extParams":_vm.extParams}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }